import { Skeleton } from '@pancakeswap/uikit'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { PoolState } from '@/hooks/v3/types'
import { useFeeTierDistribution } from '@/hooks/v3/useFeeTierDistribution'
import { FeeTierPercentageBadge } from './FeeTierPercentageBadge'
import { FEE_AMOUNT_DETAIL } from './shared'
import { Typography } from '@/components/ui/typography'
import clsx from 'clsx'
import { Button } from '@/components/ui/button'
import { FlameIcon } from 'lucide-react'

interface FeeOptionProps {
  feeAmount: FeeAmount
  largestUsageFeeTier?: FeeAmount
  active: boolean
  distributions: ReturnType<typeof useFeeTierDistribution>['distributions']
  poolState: PoolState
  onClick: () => void
  isLoading?: boolean
}

export function FeeOption({
  feeAmount,
  active,
  poolState,
  distributions,
  onClick,
  largestUsageFeeTier,
  isLoading,
}: FeeOptionProps) {
  return (
    <button type={'button'} onClick={onClick} className={'block hover:opacity-80 cursor-pointer'}>
      <div
        className={clsx('rounded-xl py-4 border bg-background', {
          'border-muted-foreground': active,
        })}
      >
        <div className={'flex flex-col items-center gap-2 px-3'}>
          <Typography className={'flex items-center gap-1'}>
            {FEE_AMOUNT_DETAIL[feeAmount].label}%{' '}
            {feeAmount === largestUsageFeeTier && <FlameIcon className={'size-4 text-destructive fill-destructive'} />}
          </Typography>
          <Typography variant={'tip'} className={'text-center'}>
            {FEE_AMOUNT_DETAIL[feeAmount].description}
          </Typography>
          {isLoading ? (
            <Skeleton width="100%" height={16} />
          ) : distributions ? (
            <FeeTierPercentageBadge distributions={distributions} feeAmount={feeAmount} poolState={poolState} />
          ) : null}
        </div>
      </div>
    </button>
  )
}
